import type { CurrencyMetadata, ProductMetadata } from 'indices-list'
import { BuyButton } from '../buy/button'
import type { InvestStorage } from '../storage/interface'
import { InputComponent } from './input/components'
import { ReceivedComponent as SellReceivedComponent } from './received'

interface SellProps {
  productMetadata: ProductMetadata
  inputAmount: string
  store: InvestStorage
  isButtonDisabled: boolean
  isTransactionInPending: boolean
  isRetry: boolean
  isProcessing: boolean
  onInputChange: (amount: string) => void
  onAssetChange: (asset: CurrencyMetadata) => void
  onButtonClick: () => void
}

export const SellComponent = ({
  productMetadata,
  inputAmount,
  store,
  isButtonDisabled,
  isProcessing,
  onInputChange,
  onAssetChange,
  onButtonClick,
  isTransactionInPending,
  isRetry,
}: SellProps) => {
  return (
    <>
      {/* {!isRetry && !isTransactionInPending && ( */}
      <>
        <InputComponent
          receivedSymbol={productMetadata.symbol}
          inputAmount={inputAmount}
          input={store.input}
          onInputChange={onInputChange}
        />

        <SellReceivedComponent
          whiteList={
            productMetadata.symbol !== 'zcx'
              ? productMetadata.acceptedCurrencies
              : [productMetadata.acceptedCurrencies[0]]
          }
          asset={store.output.asset}
          onAssetChange={onAssetChange}
          isDebounce={store.isDebounce}
          output={store.output}
        />
      </>
      {/* )} */}
      <BuyButton
        isDisabled={isButtonDisabled}
        isProcessing={isProcessing}
        isTransactionInPending={isTransactionInPending}
        isRetry={isRetry}
        investState={store.investState}
        productMetadata={productMetadata}
        handleClick={onButtonClick}
      />
    </>
  )
}
